if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        
        const productLimit = parseInt(submitButton.getAttribute('data-product-limit')) || 999;
        const productId = submitButton.getAttribute('data-product-id');
        
        if (productId && window.productQuantities && window.productQuantities[productId]) {
          if (window.productQuantities[productId] >= productLimit) {
            this.handleErrorMessage('This product is already in your cart and has reached the maximum quantity limit.');
            submitButton.classList.remove("loading");
            return false;
          }
        }

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        
        // Construct the payload object
        let formData = new FormData(this.form);
        let data = {};
        formData.forEach((value, key) => {
             // Handle array inputs correctly if needed, or simple assignment for standard fields
             if (data[key]) {
                 if (!Array.isArray(data[key])) {
                     data[key] = [data[key]];
                 }
                 data[key].push(value);
             } else {
                 data[key] = value;
             }
        });

        // Add sections to data
        const sections = [];
        if (this.cartNotification) {
             const notificationSections = this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id);
             sections.push(...notificationSections);
             this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
             const itemSections = this.cartItems
              .getSectionsToRender()
              .map((section) => section.section);
             sections.push(...itemSections);
        }

        if (sections.length > 0) {
            data.sections = sections;
        }
        
        data.sections_url = window.location.pathname;


        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["Content-Type"] = "application/json";
        config.body = JSON.stringify(data);
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }

            /* ── BACKGROUND gift processing ───────────────────────────────
             * Do NOT return this promise. Returning it would block .finally()
             * — and therefore the drawer-open — until /cart.js + gift-add
             * fetches all complete (~400–700 ms).
             *
             * Instead: fire-and-forget. The drawer opens instantly in
             * .finally(). After gifts settle, cart:updated + a silent
             * updateCustomCartDrawer() refresh the drawer content. ──────── */
            this.maybeAddGifts(parsedState).then((finalCart) => {
              if (this.cartNotification) {
                this.cartNotification.renderContents(finalCart);
                document.querySelector('cart-notification').open();
              }
              if (this.cartItems) {
                this.cartItems.renderContents(finalCart);
              }

              document
                .querySelector(".product-form__error-message-wrapper")
                ?.classList.add("no-js-inline");

              const productLimit = parseInt(submitButton.getAttribute('data-product-limit')) || 999;
              if (productId && finalCart.items) {
                const cartItem = finalCart.items.find(item => item.product_id === parseInt(productId));
                if (cartItem) {
                  if (!window.productQuantities) window.productQuantities = {};
                  window.productQuantities[productId] = cartItem.quantity;

                  if (cartItem.quantity >= productLimit) {
                    submitButton.disabled = true;
                    submitButton.textContent = 'Already in Cart';
                  }
                }
              }

              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: finalCart }
              }));

              /* Silent drawer refresh after gift state is finalised.
               * Pass finalCart through so removeUpsellIfAlone can reuse it
               * instead of issuing another /cart.js fetch. */
              if (window.updateCustomCartDrawer) window.updateCustomCartDrawer(finalCart);
            }).catch((e) => console.error('[PF] Background gift error:', e));

            /* Return nothing — .finally() runs immediately after /cart/add.js */
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            
            const productLimit = parseInt(submitButton.getAttribute('data-product-limit')) || 999;
            if (productId && window.productQuantities && window.productQuantities[productId] >= productLimit) {
              submitButton.disabled = true;
            } else {
              submitButton.removeAttribute("disabled");
            }
            
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
            document.documentElement.classList.remove("overflow-hidden");

            // if(window.upcartRefreshCart){
            //   upcartRefreshCart();
            //   window.freeGiftPromo.init();
            // }
            // if(window.upcartOpenCart){
            //   upcartOpenCart();
            // }
            if(window.custom_cart_drawer){
              const openDrawer = () => {
                document.getElementById('cart-drawer-custom').classList.add('active');
                document.body.classList.add('overflow-hidden');
                document.documentElement.classList.add("overflow-hidden");
                const overlay = document.querySelector('.cart-drawer-section .cart-overlay');
                if (overlay) {
                  overlay.classList.add('active');
                }
              };
              const renderPromise = window.updateCustomCartDrawer();
              if (renderPromise && typeof renderPromise.then === 'function') {
                renderPromise.then(openDrawer).catch(openDrawer);
              } else {
                openDrawer();
              }
            }
            if (this.closest('.collection-popup')) {
              this.closest('.collection-popup').classList.remove('active');
              // Add fallback for simply object
              if (window.simply && window.simply.prodHandle) {
                document.querySelector('body').classList.remove(`${window.simply.prodHandle}`);
              }
            }
          });
      }

      maybeAddGifts(parsedState) {
        var cfg = window.fgpConfig;
        if (!cfg || !cfg.enabled) {
          return Promise.resolve(parsedState);
        }

        // parsedState from /cart/add.js is a line item object, NOT the full cart.
        // total_price is undefined on it, making threshold checks always fail.
        // Fetch the real cart first.
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var total = cart.total_price || 0;
            (cart.items || []).forEach(function(item) {
              if (item && item.properties && item.properties._free_gift === 'true') {
                total -= item.line_price || 0;
              }
            });
            total = Math.max(0, total);

            var hasGift = function(variantId) {
              return (cart.items || []).some(function(item) {
                return item &&
                  item.variant_id === variantId &&
                  item.properties &&
                  item.properties._free_gift === 'true';
              });
            };

            var giftsToAdd = [];
            var t1 = cfg.tier1;
            if (t1 && t1.variantId && t1.threshold > 0 && total >= t1.threshold && !hasGift(t1.variantId)) {
              giftsToAdd.push(t1.variantId);
            }
            var t2 = cfg.tier2;
            if (t2 && t2.variantId && t2.threshold > 0 && total >= t2.threshold && !hasGift(t2.variantId)) {
              giftsToAdd.push(t2.variantId);
            }
            var t3 = cfg.tier3;
            if (t3 && t3.valid && t3.variantId && t3.threshold > 0 && total >= t3.threshold && !hasGift(t3.variantId)) {
              giftsToAdd.push(t3.variantId);
            }

            if (giftsToAdd.length === 0) {
              return cart;
            }

            var items = giftsToAdd.map(function(variantId) {
              return { id: variantId, quantity: 1, properties: { _free_gift: 'true' } };
            });

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .catch(function() {
              return cart;
            });
          })
          .catch(function() {
            return parsedState;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}